import { BaseModel } from './base.model';
import { JsonObject } from '../helpers';
import { McpToolModel } from './mcp-tool/mcp-tool.model';

type McpServerMeta = {
  category: string;
  tags: string[];
};

type McpServerSource = {
  project: string;
  upstream: string;
  branch: string;
  directory: string;
};

export class McpServerModel extends BaseModel {
  type: string;
  name: string;
  description: string;
  icon: string;
  title: string;
  category: string;
  tags: string[];
  image: string;
  source: McpServerSource;
  toolCount: number;
  tools: McpToolModel[];
  updatedAt: string;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof McpServerModel, unknown>;

    this.type = (data.type as string) || '';
    this.name = (data.name as string) || '';
    this.description = (data.description as string) || '';
    this.icon = (data.icon as string) || '';
    this.title = (data.title as string) || '';
    this.image = (data.image as string) || '';
    this.source = (data.source as McpServerSource) || {
      project: '',
      upstream: '',
      branch: '',
      directory: '',
    };
    this.toolCount = (data.toolCount as number) || 0;
    this.tools = ((data.tools as JsonObject[]) || []).map((tool) => new McpToolModel(tool));
    this.updatedAt = (data.updatedAt as string) || '';

    this.category = '';
    this.tags = [];

    // meta is already in use in BaseModel, so flatten it out
    if (data.meta) {
      const { category, tags } = data.meta as McpServerMeta;
      if (category) {
        this.category = category;
      }

      if (tags) {
        this.tags = tags;
      }
    }
  }
}
